import React from 'react';

import { Box, Text } from '@mantine/core';
import { PackageUtilizationReport } from 'types';
import { capitalize } from 'utils/formatters';

type ExpectationCellProps = {
  packageUtilizationReport: PackageUtilizationReport;
};

const ExpectationCell = ({ packageUtilizationReport }: ExpectationCellProps): JSX.Element => {
  const noFrequencyAvailable =
    packageUtilizationReport.expectedFrequencyUnit === null ||
    packageUtilizationReport.expectedFrequencyValue === null;

  if (noFrequencyAvailable) {
    return (
      <Box display='flex' sx={{ justifyContent: 'center' }}>
        <Text>Multiple</Text>
      </Box>
    );
  }

  const value = packageUtilizationReport.expectedFrequencyValue;
  const formattedValue = value % 1 === 0 ? value.toString() : value.toFixed(2).replace(/\.?0+$/, '');

  const unit = capitalize(packageUtilizationReport.expectedFrequencyUnit);
  const message = `${formattedValue}x per ${unit}`;

  return (
    <Box display='flex' sx={{ justifyContent: 'center' }}>
      <Text>{message}</Text>
    </Box>
  );
};

export default ExpectationCell;
